import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '46e3e2b3-7184-4fea-bfe6-377cb87115b7',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '05ebe4c8-537a-4641-b285-41f17092ed2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 74,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.010309
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'card_red_glow',
      parent: '46e3e2b3-7184-4fea-bfe6-377cb87115b7',
      data: ''
    },
    {
      id: 'b01f1e35-a787-43c4-a4d1-e540b78b33c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'danger_icon',
      parent: '05ebe4c8-537a-4641-b285-41f17092ed2a',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class DangerStackGlowLayout {
  static raw = raw;
  root: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
